import { render } from "./hardware_x_body_banner3.vue?vue&type=template&id=df54e1ca&scoped=true"
import script from "./hardware_x_body_banner3.vue?vue&type=script&lang=js"
export * from "./hardware_x_body_banner3.vue?vue&type=script&lang=js"

import "./hardware_x_body_banner3.vue?vue&type=style&index=0&id=df54e1ca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df54e1ca"]])

export default __exports__